import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ticketStatus',
})
export class TicketStatusPipe implements PipeTransform {
  transform(value: string, key: string): unknown {
    if (key?.toLowerCase() === 'status') {
      return this.convertStatus(value);
    }
    return value;
  }

  convertStatus(value: string) {
    switch (value?.toLowerCase()) {
      case 'o':
        return 'Open';
      case 'c':
        return 'Closed';
      case 'i':
        return 'Immediately Closed';
      case 'w':
        return 'Waiting';
      case 'd':
        return 'Dormant';
    }
  }
}
